import {LocList} from '../../@crema/services/db/locList';
import {GET_LOC_LIST} from '../../types/actions/LocList.actions';
import {AppActions} from '../../types';

let initialState: {locsList: LocList[]};
initialState = {
  locsList: [],
};

const locListReducer = (state = initialState, action: AppActions) => {
  switch (action.type) {
    case GET_LOC_LIST:
      return {
        ...state,
        locsList: action.payload,
      };

    default:
      return state;
  }
};
export default locListReducer;
